var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.08,
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#007FCF",
    stroke: "#007FCF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8704 23.1315C27.8704 26.1133 26.1133 27.8704 23.1315 27.8704H16.643C13.6536 27.8704 11.8965 26.1133 11.8965 23.1315V16.6354C11.8965 13.6536 12.9918 11.8965 15.9736 11.8965H17.6395C18.2381 11.8965 18.8017 12.1783 19.1608 12.6571L19.9215 13.6688C20.2814 14.1467 20.8445 14.4283 21.4428 14.4295H23.8009C26.7903 14.4295 27.8932 15.9508 27.8932 18.9935L27.8704 23.1315Z",
    stroke: "#007FCF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4786 23.7917C27.4786 26.125 25.831 27.5 23.035 27.5H16.9508C14.1476 27.5 12.5 26.125 12.5 23.7917V18.7083C12.5 16.375 13.5271 15 16.3231 15H17.8852C18.4464 15 18.9749 15.2205 19.3117 15.5952L20.025 16.3869C20.3625 16.7609 20.8905 16.9812 21.4515 16.9821H23.6626C26.4658 16.9821 27.5 18.1726 27.5 20.5536L27.4786 23.7917Z",
    stroke: "#007FCF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8818 22.0756H23.8764",
    stroke: "#007FCF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderBlue);
export default __webpack_public_path__ + "static/media/folder_blue.9f8f511bc47f2536234fc0d89f2510d4.svg";
export { ForwardRef as ReactComponent };